import $http from '../../shared/http';

export const heard_about_us_from = {
  namespaced: true,
  state: () => {
    return {
      heardAboutUsFromsForSelect: null,
    };
  },
  getters: {
    getHeardAboutUsFromsForSelect: (state) => (currentLanguage) => {
      const heardAboutUsFroms = state?.heardAboutUsFromsForSelect ?? [];
      if (!currentLanguage || !heardAboutUsFroms.length) {
        return [];
      }

      return (
        heardAboutUsFroms?.map?.((heardAboutUsFroms) => {
          return {
            value: heardAboutUsFroms.value,
            text:
              heardAboutUsFroms.localisations?.[currentLanguage]?.name || heardAboutUsFroms.text,
          };
        }) ?? []
      );
    },
  },
  mutations: {
    setHeardAboutUsFromsForSelect: (state, payload) => (state.heardAboutUsFromsForSelect = payload),
  },
  actions: {
    async loadHeardAboutUsFromsForSelect({ commit }) {
      return $http('v2')
        .get('/heard_about_us_froms')
        .then((response) => {
          commit('setHeardAboutUsFromsForSelect', response.data.data);
          return response;
        });
    },
  },
};
